import React from 'react'
import Typography from "@material-ui/core/Typography"
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles"
import right from '~/images/icons/right.svg'
import { WHITE_COLOR } from "~/constants/colors"
import { useMediaQuery } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) => createStyles({
    linkContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        backgroundColor: WHITE_COLOR,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
        cursor: 'pointer',
        padding: '16px 24px 16px 32px',
        transition: '0.5s',
        '&:hover': {
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
        },
        [theme.breakpoints.down('md')]: {
            padding: '12px 16px'
        },
        [theme.breakpoints.down('md')]: {
            padding: '8px 24px 8px 8px'
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            padding: 16
        }
    },
    imageContainer: {
        width: 160,
        height: 160,
        marginRight: 32,
        [theme.breakpoints.down('md')]: {
            width: 120,
            height: 120,
            marginRight: 24
        },
        [theme.breakpoints.down('sm')]: {
            width: 144,
            height: 144,
            marginRight: 24
        },
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            marginBottom: 16,
            alignSelf: 'center'
        }
    },
    image: {
        width: '100%',
        height: '100%'
    },
    linkRightBlock: {
        flexGrow: 1,
        display: 'flex'
    },
    textBlock: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center'
    },
    arrowBlock: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    }
}));

interface Props {
  href?: string
  imagePath: string,
  imagePathWebP?: string,
  linkText: string
}
const Link = ({href, imagePath, imagePathWebP, linkText}: Props) => {
  const classes = useStyles();
  const clickHandler = () => {
    if(href) {
      window.open(href, '_blank');
    }
  };
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <div onClick={clickHandler} className={classes.linkContainer}>
      <div className={classes.imageContainer}>
        <picture>
          <source type="image/webp" srcSet={imagePathWebP}/>
          <source type="image/png" srcSet={imagePath}/>
          <img src={imagePath}  alt={imagePath} className={classes.image}/>
        </picture>
      </div>
      <div className={classes.linkRightBlock}>
        <div className={classes.textBlock}>
          <Typography variant={ isTablet ? 'body1' : 'subtitle1'}>{linkText}</Typography>
        </div>
        <div className={classes.arrowBlock}>
          <img src={right} alt="right"/>
        </div>
      </div>
    </div>
  );
}
export default Link;
